














import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from "@flashpointbv/solar-service-container";

@Component({
  name: 'sub-categories-slider',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop({default: []}) readonly subCategories?: Array<object>;

  private slideOptions: object = {
    loop: false,
    slidesPerView: 'auto',
    watchSlidesProgress: true,
    touchRatio: 1,
    freeMode: true
  };

  private get sortedSubCategories(): object {
    return this.subCategories.sort((a, b) => {
      return a['position'] - b['position'];
    });
  }

  private mounted(): void {
    const placeholder = document.getElementById('mobileCategoryPlaceholder');
    if (placeholder) {
      placeholder.style.visibility = 'hidden';
    }
  }
}
